module.exports = __webpack_public_path__ + "media/images/surveyor-a87c5e95.svg";